var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"childPageWrap preview"},[(_vm.isEmptyPage)?_c('i',{staticClass:"iconfont icon-page"}):_c('div',{ref:"canvas",staticClass:"canvas",style:(Object.assign({}, {
      width: _vm.getCanvasStyleData.width + 'px',
      height: _vm.getCanvasStyleData.height + 'px',
      backgroundSize: "100% 100%",
      backgroundRepeat: 'no-repeat',
      transformOrigin: '0px 0px'
    }, _vm.getCanvasStyleData.backPicSrc ? {
      backgroundImage: ("url(" + (_vm.getCanvasStyleData.backPicSrc) + ")")
    } : {
      backgroundColor: _vm.getCanvasStyleData.backgroundColor || ''
    }))},_vm._l((_vm.useableComponentsData),function(item){return _c('ComponentWrapper',{key:item.id,attrs:{"config":item,"currentComps":_vm.currentComps,"childPageComps":_vm.useableComponentsData,"allBtnPressMap":_vm.isPreview ? _vm.allBtnPressMap : {}},on:{"changeCurComp":_vm.changeCurComp,"changePage":_vm.changePage,"changeBtnPress":_vm.changeBtnPress}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }